import { assign, map, isEmpty, findIndex, get } from "lodash";
import http from '../../api/index'
import Auth from '../../model/auth';


function _setToken(token){
    if(token){
        http.defaults.headers = {
            'Authorization': `Bearer ${token}`,
            'X-Requested-With': 'XMLHttpRequest'
        }
    }else{
        http.defaults.headers = {
            'X-Requested-With': 'XMLHttpRequest'
        }
    }
}

let user = localStorage.getItem('_auth_user') ? JSON.parse(localStorage.getItem('_auth_user')) : null;
if(user && user.authtoken){
    _setToken(user.authtoken);
}

let penaltyTime = localStorage.getItem('_passcode_fail');
let defaultPenaltyTime = penaltyTime ? parseInt(penaltyTime) : null;

export default function createProfileModule() {
    return {
        namespaced: true,

        state: () => ({
            passcodeFailCounter: 0,
            profile: new Auth(user),
            equipment: null,
            penaltyTime: defaultPenaltyTime,
            timestamp: Date.now()
        }),

        getters: {
            onPasscodePenalty: (state) => {
                if(state.passcodeFailCounter >= 3){
                    return true;
                }
                if(state.penaltyTime){
                    if(state.penaltyTime > new Date().getTime()){
                        return true;
                    }
                }
                return false;
            },
            passcodeFailCounter: (state) => state.passcodeFailCounter,
            tfas: (state) => state.profile.tfas,
            profile: (state) => state.profile,
            role: (state) => state.profile.getRole(),
            hasRole: (state) => {
                if(!state.profile){
                    return false;
                }
                return state.profile.getRole() !== ''
            },
            authEquipment: (state) => state.profile._equipment,
            timestamp: (state) => state.timestamp,
        },

        actions: {
            triggerResetPassword({ commit, state }, email) {
                return http.post('/forgot-password', { email: email})
                    .then(res => {
                        return res.data;
                    });
            },
            getUserByResetPasswordToken({ commit, state }, token) {
                return http.get(`/forgot-password/get/${token}`)
                    .then(res => {
                        return res.data;
                    });
            },

            resetPassword({ commit, state }, data = {}) {
                return http.post('/reset-password', data)
                    .then(res => {
                        return res.data;
                    });
            },

            getUserProfile({ commit, state }) {
                if(state.user){
                    return new Promise(resolve => {
                       resolve(state.user);
                    });
                }
                return http.get('/me', {})
                    .then(res => {
                        let user = localStorage.getItem('_auth_user') ? JSON.parse(localStorage.getItem('_auth_user')) : null;
                        if(user && user.authtoken){
                            res.data.authtoken = user.authtoken;
                        }
                        commit('setProfile', new Auth(res.data));
                        return res.data;
                    }).catch(() => {
                        localStorage.removeItem('_auth_user');
                        localStorage.removeItem('_auth_token');
                        commit('setProfile', new Auth());
                    });
            },

            updateUser({ commit, state }, data = {}) {
                return http.patch('/me', data)
                    .then(res => {
                        commit('updateUser', data);
                        return res.data;
                    })
            },

            verifyUser2FA({ commit, state }, data = {}) {
                return http.post(`/my/2fa/${data.id}`, data)
                    .then(res => {
                        let tfas = res.data;
                        return tfas;
                    })
            },

            updateUser2FA({ commit, state }, data = {}) {
                return http.patch(`/my/2fa/${data.id}`, data)
                    .then(res => {
                        let tfas = res.data;
                        return tfas;
                    })
            },

            login({ commit, state }, data = {}) {
                return http.post('/login', {
                    email: get(data, 'email'),
                    password: get(data, 'password'),
                    code: get(data, 'code'),
                    auth_type: get(data, 'auth_type'),
                }).then((res) => {
                    if (res.data.authtoken) {
                        _setToken(res.data.authtoken);
                    }
                    return res.data;
                })
            },

            logout({ commit, state }, data = {}) {
                http.get('/logout');
                commit('setProfile', new Auth());
                localStorage.removeItem('_auth_user');
                localStorage.removeItem('_auth_token');
                localStorage.removeItem('_passcode_fail');
            }
        },

        mutations: {
            increasePasscodeFailCounter(state){
                state.passcodeFailCounter++;
                state.timestamp = Date.now();
                if(state.passcodeFailCounter >= 3){
                    let expiredTime = new Date().getTime();
                    expiredTime += (5 * 60 * 1000);
                    state.penaltyTime = expiredTime;
                    localStorage.setItem('_passcode_fail', expiredTime);
                }
            },
            resetPasscodeFailCounter(state){
                state.passcodeFailCounter = 0;
                state.timestamp = Date.now();
            },
            updateUser(state, user){
                state.profile.updateUser(user);
                state.timestamp = Date.now();
            },
            setProfile(state, profile){
                _setToken(profile.authtoken);
                state.profile = profile;
                state.timestamp = Date.now();
            },
            loginEquipment(state, equipment){
                state.profile.setEquipment(equipment);
                state.timestamp = Date.now();
            },
            logoutEquipment(state){
                state.profile.setEquipment(null);
                state.timestamp = Date.now();
            }
        },
    }
}
